import {Controller} from "stimulus";
import {EventCurrencyChanged} from "../events";
import {setActiveCurrency, getActiveCurrency} from "../util/currency";

export default class extends Controller {
  static targets = ["button", "searchInput", "currencyGroup", "noSearchResults"];

  connect() {
    this.disableCurrencyDropdown = document.body.dataset.disableCurrencyDropdown === "true";

    window.addEventListener(EventCurrencyChanged, () => {
      let currencyCode = getActiveCurrency();

      this._updateButton(currencyCode);
      this._updateSelectedCurrency(currencyCode);
    });
  }

  _updateButton(currencyCode) {
    this.buttonTargets.forEach(buttonTarget => {
      buttonTarget.textContent = currencyCode.toUpperCase()
    });
  }

  _updateSelectedCurrency(currencyCode) {
    let oldElement = document.querySelector("div.currency-selector-item.active");
    if (oldElement) oldElement.classList.remove("active");

    let newElement = document.querySelector(`div.currency-selector-item[data-iso-code='${currencyCode}']`);
    newElement.classList.add("active");
  }

  _showNoSearchResultsElement(show = true) {
    let text = this.noSearchResultsTarget.dataset.text;
    this.noSearchResultsTarget.innerText = show ? text : "";
  }

  _resetSearchInput() {
    this.searchInputTarget.value = "";
    this.handleSearchInput();
  }

  showModal(show = true) {
    if (this.disableCurrencyDropdown) return;
    if (show) this._resetSearchInput();

    window.dispatchEvent(new CustomEvent("show-currency-selector", {detail: show}));
  }

  handleSearchInput() {
    let query = this.searchInputTarget.value.toLowerCase();
    let hiddenGroups = 0;

    this.currencyGroupTargets.forEach(currencyGroup => {
      Array.from(currencyGroup.children).forEach(currencyItem => {
        currencyItem.classList.toggle("tw-hidden", currencyItem.innerText.trim().toLowerCase().indexOf(query) < 0)
      });

      let hasResults = currencyGroup.querySelectorAll("div.currency-selector-item:not(.tw-hidden)").length > 0
      currencyGroup.classList.toggle("tw-hidden", !hasResults);
      currencyGroup.previousElementSibling.classList.toggle("tw-hidden", !hasResults);

      if (!hasResults) hiddenGroups++;
    });

    this._showNoSearchResultsElement(hiddenGroups >= 5);
  }

  selectCurrency(e) {
    if (this.disableCurrencyDropdown) return;

    const currencyCode = e.currentTarget.getAttribute("data-iso-code");
    setActiveCurrency(currencyCode);

    let event = new CustomEvent(EventCurrencyChanged, { bubbles: true, detail: { currencyCode } });
    this.element.dispatchEvent(event);

    this.showModal(false);
  }
}
